export const setCurrentTheme = (type) => {
    // const userType =  type || process.env.REACT_APP_USER_TYPE

    const userType = type
        ;
    return {
        type: userType
    }
}